<template>
  <div class="filter-filters">
    <div class="btn-link mb-2" v-if="fieldData"><a href="javascript:void(0);" :fieldData="fieldData" @click.prevent="resetFilters()" class="btn-link mb-2 pb-2 smaller-font-content">Clear Selected</a></div>
    <input-multicheckbox v-if="fieldData" :fieldData="fieldData"></input-multicheckbox>
  </div>
</template>

<script>
import InputMulticheckbox from '../InputMulticheckbox';

export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['chartFiltersFilters', 'chartDimensionFilters', 'clearFilters'],
  components: {
    InputMulticheckbox,
  },
  computed: {
    dimension() {
      return this.chartDimensionFilters.field_value;
    },
    fieldData() {
      let filters;

      switch (this.dimension) { // TODO: Use config values
        case 'Team':
          filters = this.chartFiltersFilters.teams;
          break;

        case 'Agent':
          filters = this.chartFiltersFilters.agents;
          break;

        case 'Carrier':
          filters = this.chartFiltersFilters.carriers;
          break;

        case 'State':
          filters = this.chartFiltersFilters.states;
          break;

        case 'Product':
          filters = this.chartFiltersFilters.products;
          break;

        default:
          filters = false;
          break;
      }

      return filters;
    },
  },
  methods: {
    resetFilters() {
      this.$emit('resetFilters', this.dimension);
    },
  },
  watch: {
    // Updates chart when chart type changes (API request)
    'fieldData.field_value': () => {
      // window.console.info('filters (fieldData) changed.', newValue);
    },
  },
};
</script>

<style scoped>
.btn-link {
  color: #003366;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/interactive/widgets/FilterFilters.vue?92251bac